import React from 'react';
import Classnames from 'classnames';
import {SelectedIconIcon} from '@bizzabo/icons';
import {rgbToAlfa} from '../../../../selectors/UtilSelectors';


function RegistrationTicketItem({active, id, ticketName, onClick, color1}) {
    const backgroundColor = active && color1 && `var(--page-dropdown-color-3, ${rgbToAlfa(color1, 0.15)})`;
    const fill = active && `var(--page-dropdown-color-2, ${color1})`;

    const clsText = Classnames('registration-ticket-item__text', {'color-1-border custom-color': active});
    const clsTopCircle = Classnames('registration-ticket-item__top-circle', {'color-1-border custom-color': active});
    const clsVertical = Classnames('registration-ticket-item__vertical', {'color-1-border custom-color': active});
    const clsBottomCircle = Classnames('registration-ticket-item__bottom-circle', {'color-1-border custom-color': active});
    const clsIndicator = Classnames('registration-ticket-item__indicator', {'color-1-border custom-color': active});

    return (<div className="registration-ticket-item" onClick={onClick}>
        <div className={clsText} style={{backgroundColor}}>
            <div className="registration-ticket-item__name">{ticketName}</div>
            <div className="registration-ticket-item__ticket">Ticket ID: #{id}</div>
        </div>
        <div className="registration-ticket-item__separator" style={{backgroundColor}}>
            <div className={clsTopCircle}></div>
            <div className={clsVertical}></div>
            <div className={clsBottomCircle}></div>
        </div>
        <div className={clsIndicator} style={{backgroundColor}}>
            {active && <SelectedIconIcon className="registration-ticket-item__icon" style={{fill}}/>}
            <div className="registration-ticket-item__check" />
        </div>
    </div>);
}

export default RegistrationTicketItem;
